import { Controller } from "stimulus"

export default class extends Controller {
  summary() {
    document.getElementById("ticket-summary-loading").classList.remove("d-none")
    document.getElementById("ticket-summary-content").classList.add("d-none")

    ajaxBody(this.data.get("url"))
  }
}
